import './App.css';
import Header from "../components/header/Header";
import Home from "../pages/home/Home";
import Footer from "../components/footer/Footer";
import {BrowserRouter, Route, Routes, useLocation} from "react-router";
import Products from "../pages/products/Products";
import Tutorials from "../pages/tutorials/Tutorials";
import Contact from "../pages/contact/Contact";
import Cart from "../cart/Cart";
import {createTheme, ThemeProvider} from "@mui/material";
import PhotoEditor from "../photoEditor/PhotoEditor";
import app from "../firebaseConfig/firebaseConfig";
import {getDatabase, onValue, ref} from "firebase/database";
import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import ProductPage from "../pages/products/productPage/ProductPage";
import Login from "../pages/login/Login";
import Register from "../pages/register/Register";
import EndOfOrderPage from "../checkout/components/EndOfOrderPage";
import UserPage from "../user/userPage/UserPage";
import AdminPage from "../adminPages/AdminPage";
import TermsAndConditions from "../terms/TermsAndConditions";
import Privacy from "../terms/Privacy";
import CookieConsent from "../cookieConsent/CookieConsent";
import ScrollToTop from "../scrollToTop/ScrollToTop";
import ReturnPolicy from "../terms/ReturnPolicy";
import VerifyOrder from "../pages/verifyOrder/VerifyOrder";
import Box from "@mui/material/Box";
import NotFoundPage from "../pages/notFoundPage/NotFoundPage";
import MaintenancePage from "../pages/maintenance/MaintenancePage";


const db = getDatabase(app);
const translationRef = ref(db, '/translation');
const maintenanceRef = ref(db, '/maintenance/enabled');
const langMap = {
    'en-us': 'en',
    'ro-ro': 'ro',
    'hu-hu': 'hu'
};

function MaintenanceGuard({maintenanceEnabled, children}) {
    const location = useLocation();
    const isAdminRoute = location.pathname.startsWith('/admin');
    if (maintenanceEnabled && !isAdminRoute) {
        return <MaintenancePage/>;
    }
    return children;
}

function App({queryParams}) {
    const {i18n} = useTranslation();
    const [initialized, setInitialized] = useState();
    const [maintenanceEnabled, setMaintenanceEnabled] = useState(false);

    const theme = createTheme({
        palette: {
            primary: {
                main: '#5ee197'
            },
            secondary: {
                main: '#0391b0'
            }
        }
    });

    useEffect(() => {
        onValue(translationRef, snapshot => {
            let translation = snapshot.val();
            Object.keys(translation).forEach(lng => {
                i18n.addResourceBundle(lng, 'translation', translation[lng], true, true);
            });

            let lang = i18n?.language || 'ro';

            if (langMap[lang]) {
                lang = langMap[lang.toLowerCase()];
            }

            if (lang.indexOf('-') > -1) {
                lang = 'ro';
            }

            i18n.changeLanguage(lang);
            setInitialized(true);
        })
    }, [i18n]);

    useEffect(() => {
        return onValue(maintenanceRef, (snapshot) => {
            setMaintenanceEnabled(!!snapshot.val());
        });
    }, []);

    return (initialized && <div className="app">
        <BrowserRouter>
            <ScrollToTop/>

            <ThemeProvider theme={theme}>
                <Header/>
                <Box className="container" id="container" sx={{
                    marginTop: {
                        xs: '100px',
                        md: '120px'
                    }
                }}>
                    <MaintenanceGuard maintenanceEnabled={maintenanceEnabled}>
                        <Routes>
                            <Route path="/" element={<Home/>}/>
                            <Route path="/404" element={<NotFoundPage/>}/>
                            <Route path="/editor" element={<PhotoEditor/>}/>
                            <Route path="/products" element={<Products/>}/>
                            <Route path="/tutorials" element={<Tutorials/>}/>
                            <Route path="/contact" element={<Contact/>}/>
                            <Route path="/cart" element={<Cart/>}/>
                            <Route path="/products/:id" element={<ProductPage/>}/>
                            <Route path="/sign-in" element={<Login queryParams={queryParams}/>}/>
                            <Route path="/sign-up" element={<Register queryParams={queryParams}/>}/>
                            <Route path="/ordered" element={<EndOfOrderPage/>}/>
                            <Route path="/user/:page" element={<UserPage/>}/>
                            <Route path="/admin/*" element={<AdminPage/>}/>
                            <Route path="/terms-and-conditions" element={<TermsAndConditions/>}/>
                            <Route path="/return-policy" element={<ReturnPolicy/>}/>
                            <Route path="/privacy-policy" element={<Privacy/>}/>
                            <Route path="/verifyorder" element={<VerifyOrder/>}/>
                            <Route path="/*" element={<NotFoundPage/>}/>
                        </Routes>
                    </MaintenanceGuard>
                    <CookieConsent/>
                    <Footer/>
                </Box>
            </ThemeProvider>
        </BrowserRouter>
    </div>);
}

export default App;
